import { pick } from 'ramda';
/**
 * Вспомогательные данные для преобразования
 * символов одного алфавита (или системы как в случае с римскими цифрами)
 * в визаульно похожие символы другого
 */ /**
    * Принимает массив, где каждый ключ это символ конкретного алфавита,
    * a значение массив похожих символов из других алфавитов
    * Возвращает объект, где каждый ключ это преобразуемый символ,
    * а value символ конкретного алфавита
    */
function getFlatObject(hash = {}) {
  return Object.entries(hash).reduce((result, [originChar, similarChars]) => {
    /* eslint-disable */similarChars.forEach(similarChar => result[similarChar] = originChar);
    /* eslint-enable */
    return result;
  }, {});
}
/**
 * Возвращает функцию для преобразования похожих символов в
 * строке на оригинальные символы конкретного алфавита
 */
function getReplaceToOriginals(dictionary) {
  const regExpStr = Object.keys(dictionary).join('|');
  const regExp = new RegExp(regExpStr, 'ig');
  return (str = '') => str.replace(regExp, matched => dictionary[matched.toUpperCase()]);
}
// латиница
export const CAPITAL_LATINS_TO_ANOTHER = {
  I: ['\u0406'],
  X: ['\u0425'],
  K: ['\u041a'],
  E: ['\u0415'],
  H: ['\u041d'],
  B: ['\u0412'],
  A: ['\u0410'],
  P: ['\u0420'],
  O: ['\u041e'],
  C: ['\u0421'],
  M: ['\u041c'],
  T: ['\u0422'],
  Y: ['\u0423']
};
export const CAPITAL_SIMILARS_TO_LATINS = getFlatObject(CAPITAL_LATINS_TO_ANOTHER);
export const CAPITAL_SIMILAR_LATINS_STR = Object.keys(CAPITAL_SIMILARS_TO_LATINS).join('');
export const latinsToSimilars = getReplaceToOriginals(CAPITAL_LATINS_TO_ANOTHER);
export const similarsToLatins = getReplaceToOriginals(CAPITAL_SIMILARS_TO_LATINS);
// римские цифры
export const CAPITAL_ROMAN_LIST = ['\u0049', '\u0056', '\u0058', '\u004c', '\u0043', '\u0044', '\u004d'];
export const CAPITAL_ROMANS_STR = CAPITAL_ROMAN_LIST.join('');
export const CAPITAL_ROMANS_TO_ANOTHER = pick(CAPITAL_ROMAN_LIST, CAPITAL_LATINS_TO_ANOTHER);
export const CAPITAL_SIMILARS_TO_ROMANS = getFlatObject(CAPITAL_ROMANS_TO_ANOTHER);
export const CAPITAL_SIMILAR_ROMANS_STR = Object.keys(CAPITAL_SIMILARS_TO_ROMANS).join('');
export const similarsToRomans = getReplaceToOriginals(CAPITAL_SIMILARS_TO_ROMANS);
// кириллица
const CAPITAL_CYRILLICS_TO_ANOTHER = {
  К: ['\u004b'],
  Е: ['\u0045'],
  Н: ['\u0048'],
  Х: ['\u0058'],
  В: ['\u0042'],
  А: ['\u0041'],
  Р: ['\u0050'],
  О: ['\u004f'],
  С: ['\u0043'],
  М: ['\u004d'],
  Т: ['\u0054'],
  У: ['\u0059']
};
export const CAPITAL_SIMILARS_TO_CYRILLICS = getFlatObject(CAPITAL_CYRILLICS_TO_ANOTHER);
export const CAPITAL_SIMILAR_CYRILLICS_STR = Object.keys(CAPITAL_SIMILARS_TO_CYRILLICS).join('');
export const similarsToCyrillics = getReplaceToOriginals(CAPITAL_SIMILARS_TO_CYRILLICS);